type SetterFunc<T> = (oldValue: T) => T
export type SetterVal<T> = T | SetterFunc<T>
export type Setter<T> = (value: SetterVal<T>) => void

export function resolveSetterVal<T>(oldValue: T, value: SetterVal<T>): T {
    if (typeof value === "function") {
        const x = value as SetterFunc<T>
        return x(oldValue)
    }
    return value
}